import { useState } from 'react';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import { sendWelcomeEmailToDiners } from 'src/common/features/DinersManagement/functions/sendWelcomeEmailToDiners';

export type UseSendWelcomeEmailToDinersProps = {
  corpId: string;
  onSuccess: (dinerIds: string[]) => void;
  onError: (
    error: IErrorResponse | SdkErrorResponse,
    dinerIds: string[]
  ) => void;
};

export type UseSendWelcomeEmailToDinersReturn = {
  sendEmail: (dinerIds: string[]) => Promise<void>;
  isLoading: boolean;
};

export const useSendWelcomeEmailToDiners = ({
  corpId,
  onSuccess,
  onError,
}: UseSendWelcomeEmailToDinersProps): UseSendWelcomeEmailToDinersReturn => {
  const [isLoading, setIsLoading] = useState<boolean>();

  const sendEmail = async (dinerIds: string[]) => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      await sendWelcomeEmailToDiners(corpId, dinerIds);
      onSuccess(dinerIds);
    } catch (error) {
      onError(error, dinerIds);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendEmail,
    isLoading,
  };
};
